import { Controller } from '@hotwired/stimulus';
import { fadeIn, fadeOut } from '../helpers';

export default class extends Controller {
    static get targets() {
        return ['close'];
    }

    connect() {
        this._type = this.element.dataset.popupType;
        this._id = this.element.dataset.popupId;
        this._delay = parseFloat(this.element.dataset.popupDelay) * 1000;

        if (this._type === 'background') {
            this._container = this.element.querySelector('.popup__container');
            this._dialog = this.element.querySelector('.popup__dialog');
            this._content = this.element.querySelector('.popup__content');

            this._container.addEventListener('mousedown', (e) => {
                if (e.target === this._container) {
                    this.close();
                }
            });

            this._dialog.addEventListener('mousedown', (e) => {
                if (e.target === this._dialog) {
                    this.close();
                }
            });

            this._content.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        if (!this.isClosed()) {
            setTimeout(() => {
                fadeIn(this.element);
            }, this._delay);
        }
    }

    closeTargetConnected(element) {
        element.addEventListener('click', () => {
            this.close();
        });
    }

    close() {
        this.addToSessionStorage();
        fadeOut(this.element);
    }

    addToSessionStorage() {
        sessionStorage.setItem(`popup-${this._id}`, 'closed');
    }

    isClosed() {
        return sessionStorage.getItem(`popup-${this._id}`) === 'closed';
    }
}
